import { marked, Renderer } from 'marked';

const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const safeUrl = (href: string) => {
    // Check the protocol before handing a URL to the HTML renderer. Entity-encoded protocols
    // are rejected as well, since the browser would decode them in an href attribute.
    if (/[&\u0000-\u0020]/.test(href.split(/[/?#]/)[0])) return false;
    try {
        return ['http:', 'https:', 'mailto:', 'tel:'].includes(new URL(href, 'https://backoffice.invalid').protocol);
    } catch {
        return false;
    }
};

export const renderChatMarkdown = (message: string): string => {
    const renderer = new Renderer();
    const link = renderer.link;
    const image = renderer.image;
    renderer.html = ({ text }) => escapeHtml(text);
    renderer.link = function (token) {
        return safeUrl(token.href) ? link.call(this, token) : this.parser.parseInline(token.tokens);
    };
    renderer.image = function (token) {
        return safeUrl(token.href) ? image.call(this, token) : escapeHtml(token.text);
    };
    return marked(message.replace(/\\n/g, '\n'), { breaks: true, gfm: true, async: false, renderer });
};
